/**
 * Utility for conditionally joining class names together.
 * Filters out falsy values and joins remaining class names with a space.
 */
export function cn(...classes) {
    return classes.filter(Boolean).join(' ');
}
//# sourceMappingURL=cn.js.map